import React, {useState} from 'react';

const Row = (props) => {
    const {
        file,
        onDelete    = null,
    } = props;

    const getIconClass = () => {
        if (!!file.icon && file.icon !== "") {
            return file.icon+" fa-2x";
        }

        return "fas fa-file fa-2x";
    }

    const renderControls = () => {
        if ((!file.url || file.url === "") && !onDelete) {
            return null;
        }

        return (
            <div className="dropdown">
                <button
                    className="dropdown-toggle cursor-pointer text-eh-off-black h3 mb-0 p-3"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    <i className="far fa-ellipsis-v"/>
                </button>
                <div
                    className="dropdown-menu dropdown-menu-right p-0"
                    aria-labelledby="navbarDropdown"
                >
                    {!!file.url && file.url !== "" && (
                        <a className={"dropdown-item cursor-pointer"}
                           target={"_blank"}
                           href={file.url}
                        >
                            <span>View</span>
                        </a>
                    )}
                    {!!onDelete && (
                        <button className={"dropdown-item cursor-pointer border-top"}
                                onClick={() => onDelete(file)}
                        >
                            <span>Delete</span>
                        </button>
                    )}
                </div>
            </div>
        )
    }

    const renderDetails = () => {
        let details = null;

        if (!!file.created_at && file.created_at !== "") {
            details = file.created_at;
        }

        if (details === null && !!file.display_size && file.display_size !== "") {
            details = file.display_size;
        } else if (!!details && !!file.display_size && file.display_size !== "") {
            details += " - "+file.display_size;
        }

        return !details ? "-" : details;
    }

    return (
        <div className={"row-file mb-3"}>
            <div className={"icon-container py-3 pl-3 pr-0"}>
                <i className={getIconClass()} />
            </div>
            <div className={"detail-container py-3 pl-3"}>
                <div className={"details"}>
                    <div className={"upper-row mb-1 user-select-none"}>
                        {file.name}
                    </div>
                    <div className={"lower-row mb-0 user-select-none"}>
                        {renderDetails()}
                    </div>
                </div>
            </div>
            <div className={"row-controls"}>
                {renderControls()}
            </div>
        </div>
    );
}

export default Row;
